import { useNavigate, useParams, useLocation } from 'react-router-dom'
import axios from 'axios';
import { useEffect, useState, useRef } from 'react';
import EditorViewer from '../../../../codesnippet/RTEEditorViewer';
import FilePreview from '../../../FilePreview';
import AWSFileViewer from '../AWSFileViewer';
import { toast } from 'react-toastify';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const EditLabPublication = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const location = useLocation()
  const research_type = location?.state?.research_type
  const fileInputRef = useRef(null);
  const [data, setData] = useState()
  const [name, setName] = useState("")
  const [description, setDescription] = useState("")
  const [field, setField] = useState("")
  const [area, setArea] = useState("")
  const [topic, setTopic] = useState("")
  const [visibility,setVisibility]=useState("public")
  const [publication_type, setPublicationType] = useState("")
  const [file, setFile] = useState("")
  const [awsFile, setAwsFile] = useState()
  const [summary,setSummary]=useState("")
  const [loading, setLoading] = useState(false)

  const fetchPublicationDetail = async () => {
    try {
      const endpoints = {
        labtheoreticalidea: `${BASE_URL}/marketplace/university/lab-theoreticalidea`,
        lab_labexperiment: `${BASE_URL}/marketplace/university/lab-experiment`,
        prototype: `${BASE_URL}/marketplace/researcher/prototype`,
        industrialapplication: `${BASE_URL}/marketplace/researcher/industrialapplication`,
      };
      const url = endpoints[research_type];
      if (!url) {
        console.warn("Unknown type:", research_type);
        return;
      }
      const response = await axios.get(`${url}/${id}/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'x-api-key': process.env.REACT_APP_X_API_KEY,
        },
      });
      const data = response?.data
      setData(data)
      setName(data?.name)
      setSummary(data?.summary)
      setDescription(data?.description)
      setField(data?.field_of_interest)
      setArea(data?.area_of_interest)
      setTopic(data?.topic_of_interest)
      setVisibility(data?.visibility)
      setPublicationType(data?.publication_type)
      setAwsFile(data?.file)

    } catch (error) {
      console.error("Error fetching publication detail:", error);
      toast.error(error.code)
    }
    
  };
  useEffect(() => {
    if (!id) return;
    fetchPublicationDetail();
  }, [id, research_type]);

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData()
    formData.append('name', name)
    formData.append('summary',summary)
    formData.append('description', description)
    formData.append('field_of_interest', field)
    formData.append('area_of_interest', area)
    formData.append('topic_of_interest', topic)
    formData.append('visibility',visibility)
    formData.append('publication_type', publication_type)
    if (file) {
      formData.append('file', file)
    }
    try {
      setLoading(true)
      const endpoints = {
        labtheoreticalidea: `${BASE_URL}/marketplace/university/lab-theoreticalidea`,
        lab_labexperiment: `${BASE_URL}/marketplace/university/lab-experiment`,
        prototype: `${BASE_URL}/marketplace/researcher/prototype`,
        industrialapplication: `${BASE_URL}/marketplace/researcher/industrialapplication`,
      };
      const url = endpoints[research_type];
      if (!url) {
        console.warn("Unknown type:", research_type);
        return;
      }
      await axios.patch(
        `${url}/${id}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'x-api-key': process.env.REACT_APP_X_API_KEY,
          },
        }
      );
      alert("Lab Publication updated successfully")
      navigate(`/marketplace/independent_researcher/dashboard/mylabspaces/lab_publication/${id}`, {
        state: {
          research_type: research_type
        }
      })

    } catch (error) {
      console.log('error while post request', error)
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-4xl p-6">
        <div className="flex items-center gap-3 mb-6">
          <div>
            <button
              onClick={() => navigate(-1)}
              className="px-4 py-2 bg-[#e8f0f7] rounded-lg flex items-center justify-center gap-2 text-[#0f6abf] hover:bg-[#d0e0f0] transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
              <span>Back</span>
            </button>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4" encType="multipart/form-data">
          {/* Project Title */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">
                Title
              </label>
            </div>
            <input
              type="text"
              name="title"
              placeholder="Enter project title"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
           {/* Publication Summary */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                            Summary (always visible)
                            </label>
                        </div>
                        <textarea
                            name="summary"
                            rows="4"
                            placeholder="Short preview shown to everyone..."
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-y"
                            required
                            value={summary}
                            onChange={(e)=>setSummary(e.target.value)}
                        />
                    </div>
          {/* Publication Description */}
         <div>
                                <div className="flex items-center gap-2 mb-3">
                                    <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                                    <label className="text-sm font-semibold text-gray-700">
                                    Full details (restricted)
                                    </label>
                                </div>
                               
                                <div className="border border-gray-300 rounded-xl overflow-hidden">
                                      {
                                        description && (<EditorViewer  code={false} readOnly={false} value={description} setValue={setDescription} />)
                                      }
                                </div>
                                
                            </div>
          {/* Field */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">
                Field of Interest
              </label>
            </div>
            <input
              type="text"
              name="field"
              placeholder="e.g., Artificial Intelligence"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              required
              value={field}
              onChange={(e) => setField(e.target.value)}
            />
          </div>
          {/* Area */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">
                Area of Interest
              </label>
            </div>
            <input
              type="text"
              name="area"
              placeholder="e.g., AI in Healthcare"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              required
              value={area}
              onChange={(e) => setArea(e.target.value)}
            />
          </div>
          {/* Topic */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">
                Topic of Interest
              </label>
            </div>
            <input
              type="text"
              name="topic"
              placeholder="e.g., Early disease detection using deep learning"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
              required
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
            />
          </div>
          {/* Visibility Domain */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Visibility Domain
                            </label>
                        </div>
                        <select
                            name="type"
                            className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
                            style={{
                                backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'right 16px center'
                            }}
                            required
                            value={visibility}
                            onChange={(e)=>setVisibility(e.target.value)}
                        >
                            {/* <option value="">Select Domain</option> */}
                            <option value="public">Public</option>
                            <option value="private">Private</option>
                            <option value="restricted">Restricted</option>
                        </select>
                    </div>
          {/* Publication Type */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
              <label className="text-sm font-semibold text-gray-700">
                Publication Type
              </label>
            </div>
            <select
              name="type"
              className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all appearance-none"
              style={{
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right 16px center'
              }}
              required
              value={publication_type}
              onChange={(e) => {
                setPublicationType(e.target.value);
                setFile(null);
                if (fileInputRef.current) fileInputRef.current.value = "";
              }}

            >
              <option value="">Select type</option>
              <option value="pdf">PDF</option>
              <option value="doc">DOC</option>
              <option value="code">Code</option>
              <option value="image">Image</option>
              <option value="video">Video</option>
              <option value="audio">Audio</option>
            </select>
          </div>
          {/* Publication File */}
          <div>

            {

              file ? <>
                <FilePreview publication_type={publication_type} file={file} setFile={setFile} />

              </> : <>
                <div className="mt-6 flex items-center gap-2 mb-3">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700" htmlFor="projectImage">
                    Already Uploaded File
                  </label>
                </div>
                {
                  awsFile && (
                    <>
                      <AWSFileViewer publication_data={data} />
                    </>
                  )
                }
                <div className="mt-6 flex items-center gap-2 mb-3">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <label className="text-sm font-semibold text-gray-700" htmlFor="projectImage">
                    If Want to Change Upload new  {publication_type?.toUpperCase()} File
                  </label>
                </div>

                <label
                  htmlFor="projectImage"
                  className={`border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors cursor-pointer flex flex-col items-center ${publication_type ? "" : "pointer-events-none opacity-50"}`}
                >
                  <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mb-3">
                    <svg
                      className="w-5 h-5 text-[#0f6abf]"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                  </div>

                  <p className="text-sm text-gray-600">Click to upload publication file</p>
                  <p className="text-xs text-gray-400 mt-1">JPG, PNG up to 5MB</p>
                </label>
                {/* Hidden input */}
                <input
                  type="file"
                  id="projectImage"
                  name="image"
                  accept={
                    publication_type === "pdf"
                      ? "application/pdf"
                      : publication_type === "doc"
                        ? "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        : publication_type === "image"
                          ? "image/*"
                          : publication_type === "video"
                            ? "video/*"
                            : publication_type === "audio"
                              ? "audio/*"
                              : publication_type === "code"
                                ? ".js,.py,.java,.cpp,.c,.html,.css,.ts,.jsx,.tsx"
                                : "*/*" // fallback: allow all
                  }
                  className="hidden"

                  ref={fileInputRef}
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </>
            }
          </div>
          {/* Submit */}
          <button
            type="submit"
            className="mt-12 w-full py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={loading}
          >
            {loading ? (
              <>
                {/* Spinner loader */}
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Publishing...
              </>
            ) : (
              <>
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                </svg>
                Update Publication
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  )
}

export default EditLabPublication